/* ═══════════════════════════════════════════════
   tnnursery-footer.js
   – Mobile accordion for menu columns
   – Marquee scrolls continuously, never pauses on hover
   – Newsletter success / error feedback
═══════════════════════════════════════════════ */

var TNFooter = (function () {

  function isMobile() {
    return window.innerWidth <= 768;
  }

  function initAccordion(sectionId) {
    if (!isMobile()) return;

    var root = document.getElementById('tnnursery-footer-' + sectionId);
    if (!root) return;

    var cols = root.querySelectorAll('.tnfooter__menu-col');
    cols.forEach(function (col) {
      var title = col.querySelector('.tnfooter__menu-title');
      if (!title) return;

      title.addEventListener('click', function () {
        var isOpen = col.classList.contains('is-open');
        cols.forEach(function (c) { c.classList.remove('is-open'); });
        if (!isOpen) col.classList.add('is-open');
      });
    });
  }

  function initResizeHandler(sectionId) {
    var debounceTimer;
    window.addEventListener('resize', function () {
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        var root = document.getElementById('tnnursery-footer-' + sectionId);
        if (!root) return;
        var cols = root.querySelectorAll('.tnfooter__menu-col');

        if (!isMobile()) {
          cols.forEach(function (c) {
            c.classList.remove('is-open');
            var list = c.querySelector('.tnfooter__menu-list');
            if (list) list.style.display = '';
          });
        }
      }, 200);
    });
  }

  function initNewsletter(sectionId) {
    var form = document.getElementById('tnfooter-newsletter-form-' + sectionId);
    if (!form) return;

    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var input = form.querySelector('.tnfooter__email-input');
      if (input) {
        input.value = '';
        input.placeholder = 'Thanks for subscribing!';
      }
    }
  }

  /*
    initMarquee removed.

    It bailed out on `groups.length < 2` and so never ran, but it contained a
    scrollWidth read inside a while loop with appendChild between iterations —
    a forced-reflow thrash that would have activated the moment a second group
    existed. The marquee is now two halves (see tnnursery-footer.liquid), so
    that guard would no longer stop it.

    The scroll is pure CSS and needs no JS.
  */

  function init(sectionId) {
    initAccordion(sectionId);
    initResizeHandler(sectionId);
    initNewsletter(sectionId);
  }

  return { init: init };

})();